/**
 * Engagement Factories
 * Scroll, section view, language, navigation
 */

import { gtagEvent } from '../utils/gtag';

export function trackScroll(percent: number): void {
  const params = {
    percent_scrolled: percent,
    page_path: typeof window !== 'undefined' ? window.location.pathname : '',
  };
  gtagEvent('scroll', params);
}

export function trackSectionView(sectionName: string, sectionIndex: number): void {
  const params = {
    section_name: sectionName,
    section_index: sectionIndex,
  };
  gtagEvent('section_view', params);
}

export function trackLanguageChange(fromLocale: string, toLocale: string): void {
  gtagEvent('language_change', { from_locale: fromLocale, to_locale: toLocale });
}

export function trackNavLinkClick(linkText: string, linkPath: string): void {
  gtagEvent('nav_link_click', { link_text: linkText, link_path: linkPath });
}

export function trackFooterLinkClick(
  linkText: string,
  linkUrl: string,
  linkType: 'internal' | 'external' | 'social'
): void {
  gtagEvent('footer_link_click', { link_text: linkText, link_url: linkUrl, link_type: linkType });
}

export function trackMobileMenuToggle(action: 'open' | 'close'): void {
  gtagEvent('mobile_menu_toggle', { action });
}

export function trackAnnouncementClose(): void {
  gtagEvent('announcement_close', {});
}

export function trackAppError(errorName: string, componentStack: string, pagePath: string): void {
  gtagEvent('app_error', { error_name: errorName, component_stack: componentStack, page_path: pagePath });
}
